import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "services/common"
import { defaultUrlDev } from "services/rbo/import-listing"

// ------------- user import profile api for property management flow (step 3) -----------
export interface UserImportProfileType extends ResponseData {
  aboutHost: string
  airbnbHostProfileUrl: string
  hostProfileId: string
  hostProfileImageUrl: string
  languageSpokenByHost: string
  name: string
  numberOfListing: number
  active?: boolean
}

export interface UserImportProfileResponseData extends ResponseData {
  data: UserImportProfileType
}

export interface UserImportProfileResponse extends AxiosResponse {
  data: UserImportProfileResponseData
}

export interface UserImportProfileRequest extends Partial<AxiosRequestConfig> {
  params: {
    url: string
  }
}

export function userImportProfileApi(
  { params }: UserImportProfileRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: `${defaultUrlDev}/user/import-profile?url=${params.url}`,
  }) as Promise<UserImportProfileResponse>
}

// ----- review profile api for property management flow (step 4) -----------
export interface ReviewProfileResponseData extends AxiosResponse {
  data: {
    message: string
  }
}

export interface ReviewProfileResponse extends AxiosResponse {
  data: ReviewProfileResponseData
}

export interface ReviewProfileRequest extends Partial<AxiosRequestConfig> {
  params: {
    hostProfileId: number
  }
}

export function reviewProfileApi(
  { params }: ReviewProfileRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: `${defaultUrlDev}/user/review-profile`,
  }) as Promise<ReviewProfileResponse>
}
